// Sprint 44 XL - Dark mode tokens.
// Colores disenados para dark, no invertidos. Contraste AA.
// Solo path que cambian respecto a light viven aca. El resto se hereda.
const darkOverrides = {
  color: {
    primary:      '#3B82F6',
    primaryHover: '#60A5FA',
    secondary:    '#10B981',
    bg:           '#0F172A',
    surface:      '#1E293B',
    surfaceAlt:   '#0B1220',
    border:       '#334155',
    borderStrong: '#475569',
    text: {
      primary:   '#F1F5F9',
      secondary: '#94A3B8',
      muted:     '#64748B',
      inverse:   '#0F172A',
    },
    state: {
      success: '#10B981',
      warning: '#F59E0B',
      danger:  '#F87171',
      info:    '#60A5FA',
    },
    focus: '#60A5FA',
  },
  shadow: {
    sm: '0 1px 2px rgba(0, 0, 0, 0.35)',
    md: '0 4px 12px rgba(0, 0, 0, 0.45)',
    lg: '0 12px 32px rgba(0, 0, 0, 0.55)',
  },
};

export default darkOverrides;
